class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').setQuantity(this.dataset.key, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.section_id = this.dataset.sectionId;

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target, document.activeElement.getAttribute('name'));
  }

  setQuantity(key, value) {
    var input = this.querySelector(`[name='updates[]'][data-key='${key}']`);

    if (input) {
      input.value = value;

      var event = new Event('change', { bubbles: true, cancelable: true });
      input.dispatchEvent(event);
    }
  }

  updateQuantity(input, name) {
    const bundle_key = input.dataset.bundleKey;
    const key = input.dataset.key;
    const value = input.value;

    var body = false;
    var updates = {};

    if (bundle_key != 'false') {
      this.querySelectorAll(`[data-bundle-key='${bundle_key}']`).forEach((node) => {
        var key = node.dataset.key;
        updates[key] = value;
      });
    } else {
      updates[key] = value;
    }

    body = JSON.stringify({
      updates: updates,
    });

    if (!body) {
      return;
    }

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch(`${routes.cart_url}?section_id=${this.section_id}`)
          .then((r) => r.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            /* Cart Items */
            var items_target = document.querySelector('#CartContainer');
            var items_source = html.querySelector('#CartContainer');

            if (items_target && items_source) {
              items_target.innerHTML = items_source.innerHTML;
            }

            input.focus();
          });
      })
      .catch(() => {});
  }
}

customElements.define('cart-items', CartItems);
